<template>
    <b-card class="card-accent-light" header-tag="header" footer-tag="footer" no-body>
        <template v-slot:header>
            <i class="fa-solid fa-person-pregnant"></i> <strong> Maternity </strong>
            <div class="card-header-actions">
                <b-link class="card-header-action btn-minimize" @click="visible = !visible">
                    <i class="fa-regular" :class="visible ? 'fa-square-caret-up' : 'fa-square-caret-down'"></i>
                </b-link>
            </div>
        </template>
        <b-collapse v-model="visible">
            <maternity-base />
        </b-collapse>
    </b-card>
</template>
<script>
import ComponentExtension from "@/core/components/ComponentExtension"
import MaternityBase from './MaternityBase'

export default ComponentExtension.extend({
    name: "maternity-consult",
    components: {
        'maternity-base': MaternityBase
    }
})
</script>
